import { useEffect, useState } from 'react';
import { formatRemaining, nextDailyResetUtc, nextMonthlyResetUtc, nextWeeklyResetUtc } from '../lib/period';

/**
 * Top-bar UTC reset countdowns. Started life as a WP1 placeholder with its own daily-only
 * arithmetic; now renders daily + weekly (Thursday) from the WP4 period engine (`lib/period`),
 * the same functions the dashboard briefing uses.
 */
const FINAL_HOUR_MS = 60 * 60 * 1000;

function CountdownColumn({ label, remaining }: { label: string; remaining: number }) {
  const finalHour = remaining <= FINAL_HOUR_MS;
  return (
    <div className="flex flex-col items-end leading-tight">
      <span className="font-display text-[0.62rem] font-semibold uppercase tracking-[0.13em] text-text-faint">
        {label}
      </span>
      <span
        className={[
          'font-sans text-sm font-semibold tabular-nums',
          finalHour ? 'text-warning' : 'text-accent-strong',
        ].join(' ')}
      >
        {formatRemaining(remaining)}
      </span>
    </div>
  );
}

export function ResetCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const date = new Date(now);

  return (
    <div className="flex items-center gap-3 sm:gap-4" data-testid="reset-countdown">
      <CountdownColumn label="Daily reset" remaining={nextDailyResetUtc(date).getTime() - now} />
      <CountdownColumn label="Weekly reset" remaining={nextWeeklyResetUtc(date).getTime() - now} />
      <CountdownColumn label="Monthly reset" remaining={nextMonthlyResetUtc(date).getTime() - now} />
    </div>
  );
}
